var e4 = e4 || {},
    dme = dme || {};
( function () {
    'use strict';

    dme.gtm = {
        init: function () {
            var jDmeMailChimpForm = jQuery( '.js-e-form-dw-mailchimp-signup' );
            jDmeMailChimpForm.on( 'submit', function () {
                dataLayer.push( {
                    'eventCategory': 'Tilmelding til nyhedsbrev',
                    'eventAction': 'Signup',
                    'eventLabel': '{{Page URL}}',
                    'eventValue': 0,
                    'eventInteraction': true,
                    'event': 'track-ga-event'
                } );
            } );
        }
    };
}() );

